import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from './config';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const isAuth = isAuthenticated();

    if (!isAuth) {
        // Redirect to login but save the attempted location
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
